import React from 'react';
import { ReactComponent as HokErrorStatusIcon } from '../../img/status/error.svg';
import { ReactComponent as HokWaitingStatusIcon } from '../../img/status/waiting.svg';
import { ReactComponent as HokProcessingStatusIcon } from '../../img/status/processing.svg';
import { ReactComponent as HokSuccessStatusIcon } from '../../img/status/success.svg';
import { ReactComponent as HokErrorIcon } from '../../img/icons/hok-error.svg';
import {
  TRANSACTION_STATUS_INITIATED,
  TRANSACTION_STATUS_STARTED,
  TRANSACTION_STATUS_PAID,
  TRANSACTION_STATUS_COMPLETED,
  TRANSACTION_STATUS_CANCELED,
  TRANSACTION_STATUS_FAILED,
  TRANSACTION_ACTION_STATUS_REQUIRED,
  TRANSACTION_ACTION_STATUS_DONE,
} from '../../constants/userTransactions';

export const TransactionStatusIcon = React.memo(({ status, ...rest }) => {
  switch (status) {
    case TRANSACTION_STATUS_INITIATED:
    case TRANSACTION_STATUS_STARTED:
      return <HokProcessingStatusIcon {...rest} />;
    case TRANSACTION_STATUS_PAID:
    case TRANSACTION_STATUS_COMPLETED:
      return <HokSuccessStatusIcon {...rest} />;
    case TRANSACTION_STATUS_CANCELED:
    case TRANSACTION_STATUS_FAILED:
      return <HokErrorStatusIcon {...rest} />;
    default:
      return <HokWaitingStatusIcon {...rest} />;
  }
});

export const TransactionActionStatusIcon = React.memo(({ status, ...rest }) => {
  switch (status) {
    case TRANSACTION_ACTION_STATUS_DONE:
      return <HokSuccessStatusIcon {...rest} />;
    case TRANSACTION_ACTION_STATUS_REQUIRED:
      return <HokErrorIcon {...rest} />;
    default:
      return '';
  }
});
